import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { of } from "rxjs";
import { switchMap, catchError, map, tap } from "rxjs/operators";
import {
  organizationsListLoad,
  organizationsListLoadSuccess,
  organizationsListLoadFail,
} from "../actions/organizations.actions";
import { OrganizationsService } from "src/app/shared/services/organizations/organizations.service";
import { Organization } from "src/app/shared/interfaces/organization";
import { PdfReportService } from "src/app/shared/services/pdfreport/pdfreport.service";
import { FileService } from "src/app/shared/services/file/file.service";
import {
  organizationRaportLoad,
  organizationRaportLoadFail,
  organizationRaportLoadSuccess,
} from "../actions/admin/organization-raport.actions";
import { PdfReport } from "src/app/shared/interfaces/pdfreport";

@Injectable()
export class OrganizationsEffect {
  getCoursesAdminList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(organizationsListLoad),
      switchMap(() => {
        return this.organizationsService.getOrganizations().pipe(
          map((res: Organization[]) =>
            organizationsListLoadSuccess({ organizations: res }),
          ),
          catchError(({ error }) => of(organizationsListLoadFail(error))),
        );
      }),
    ),
  );

  downloadOrganizationReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(organizationRaportLoad),
      switchMap((param) => {
        return this.pdfreportService
          .downloadOrganizationReport(param.OrganizationId)
          .pipe(
            tap((res: PdfReport) => {
              this.fileService.downloadS3File(
                res.s3_url,
                param.OrganizationName,
              );
            }),
            map((res: PdfReport) =>
              organizationRaportLoadSuccess({ pdf: res }),
            ),
            catchError(({ error }) => of(organizationRaportLoadFail(error))),
          );
      }),
    ),
  );

  constructor(
    private organizationsService: OrganizationsService,
    private actions$: Actions,
    private pdfreportService: PdfReportService,
    private fileService: FileService,
  ) {}
}
